module.exports = __webpack_public_path__ + "b926baf9a026a862dc35070765de6342.svg";